export enum EventSource {
    WEB_APP = 'web_app',
    // Used in external repo only for now
    MARKETING = 'marketing',
}

export const EVENTS = {
    SHIFT_CONFIRMATION_PAGE_LOADED: 'shift_confirmation_page_loaded',
    SHIFT_CONFIRMATION_TABLE_SEARCH: 'shift_confirmation_table_search',
    SHIFT_CONFIRMATION_TABLE_SORT: 'shift_confirmation_table_sort',
    SHIFT_CONFIRMATION_SEND_ALL_CONFIRMATIONS:
        'shift_confirmation_send_all_confirmations',
    SHIFT_CONFIRMATION_SEND_ONE_CONFIRMATION:
        'shift_confirmation_send_one_confirmation',
    SHIFT_CONFIRMATION_DELETE_CONFIRMATION:
        'shift_confirmation_delete_confirmation',

    SYNC_SHIFTS_TRIGGERED: 'sync_shifts_triggered',
    SETTINGS_SYNC_TRIGGERED: 'settings_sync_triggered',
    SETTINGS_SYNC_COMPLETED: 'settings_sync_completed',
    OUTREACH_CREATED: 'callout_created',
    HOME_OUTREACH_CREATE_OPENED: 'home_outreach_create_opened',
    QUICK_OUTREACH_AUTO_START_TOGGLED: 'quick_callout_auto_start_toggled',
    QUICK_OUTREACH_AUTO_MONITOR_TOGGLED: 'quick_callout_auto_monitor_toggled',
    ACTIVITY_FEED_MARK_DONE: 'activity_feed_mark_done',
    ACTIVITY_FEED_ASSIGN: 'activity_feed_assign',
    // Any other click on an activity feed item, differentiated by the
    // `action` property (open_item, open_conversation, open_voice_call,
    // view_outreach, open_caregiver_profile, unmark_done).
    ACTIVITY_FEED_ACTION_CLICK: 'activity_feed_action_click',
    OUTREACH_ASSIGN_AND_FILL_OPENED: 'callout_assign_and_fill_opened',
    OUTREACH_ASSIGN_AND_FILL_CONFIRMED: 'callout_assign_and_fill_confirmed',
    OUTREACH_ASSIGN_AND_FILL_DISMISSED: 'callout_assign_and_fill_dismissed',

    POST_SETUP_STEP_VIEWED: 'post_setup_step_viewed',
    POST_SETUP_CONTROL_INTERACTED: 'post_setup_control_interacted',
    POST_SETUP_STEP_COMPLETED: 'post_setup_step_completed',
    POST_SETUP_STEP_SAVE_FAILED: 'post_setup_step_save_failed',
    POST_SETUP_BRIEF_COMPLETED: 'post_setup_brief_completed',
    POST_SETUP_PAIN_POINTS_SUBMITTED: 'post_setup_pain_points_submitted',

    CONNECT_EHR_FORM_VIEWED: 'connect_ehr_form_viewed',
    CONNECT_EHR_CONTROL_INTERACTED: 'connect_ehr_control_interacted',
    CONNECT_EHR_SUBMITTED: 'connect_ehr_submitted',
    CONNECT_EHR_SUBMIT_FAILED: 'connect_ehr_submit_failed',

    // Shown when a user tries to create an outreach and one or more of
    // the selected shifts has Shift.status = 'missing' (the source
    // system has marked the shift removed since we last synced). We
    // warn the coordinator but do NOT block creation.
    MISSING_SHIFT_OUTREACH_BANNER_SHOWN: 'missing_shift_outreach_banner_shown',
    MISSING_SHIFT_OUTREACH_BANNER_DISMISSED:
        'missing_shift_outreach_banner_dismissed',
    EXTENSION_INSTALLED: 'extension_installed',
    EXTENSION_UPDATED: 'extension_updated',
    EXTENSION_SIDEBAR_OPENED: 'extension_sidebar_opened',
    EXTENSION_SIDEBAR_FEED_VIEWED: 'extension_sidebar_feed_viewed',
    EXTENSION_OPEN_IN_PHOEBE_CLICKED: 'extension_open_in_phoebe_clicked',
    EXTENSION_QUICK_OUTREACH_CREATED: 'extension_quick_callout_created',
    EXTENSION_CLIENT_QUICK_OUTREACH_CREATED:
        'extension_client_quick_callout_created',
    EXTENSION_CALENDAR_SHIFT_CLICKED: 'extension_calendar_shift_clicked',
    EXTENSION_CTA_FILL_CLICKED: 'extension_cta_fill_clicked',
    EXTENSION_EHR_CAREGIVER_SEARCH_USED: 'extension_ehr_caregiver_search_used',
    EXTENSION_EHR_CAREGIVER_SEARCH_COMPLETED:
        'extension_ehr_caregiver_search_completed',
    EXTENSION_API_LIMITER_SATURATED: 'extension_api_limiter_saturated',
    EXTENSION_AUTH_BREAKER_TRIPPED: 'extension_auth_breaker_tripped',
    EXTENSION_BATCH_RESOLVE_RATE_EXCEEDED:
        'extension_batch_resolve_rate_exceeded',
    EXTENSION_INSTALL_BANNER_INSTALL_CLICKED:
        'extension_install_banner_install_clicked',
    EXTENSION_INSTALL_BANNER_DISMISSED: 'extension_install_banner_dismissed',

    DEMO_PAGE_VIEWED: 'demo_page_viewed',
    DEMO_CALL_INITIATED: 'demo_call_initiated',

    WEBSOCKET_LIVENESS_TIMEOUT: 'websocket_liveness_timeout',
    WEBSOCKET_EVENT_SEQUENCE_GAP_DETECTED:
        'websocket_event_sequence_gap_detected',

    NOTIFICATION_RECEIVED: 'notification_received',
    NOTIFICATION_TOAST_DEDUPED: 'notification_toast_deduped',
    NOTIFICATION_TOAST_SHOWN: 'notification_toast_shown',
    NOTIFICATION_TOAST_THROTTLED: 'notification_toast_throttled',
    NOTIFICATION_BROWSER_SHOWN: 'notification_browser_shown',
    NOTIFICATION_CLICKED: 'notification_clicked',
    NOTIFICATION_MARKED_SEEN: 'notification_marked_seen',
    NOTIFICATION_DISMISSED: 'notification_dismissed',

    EMAIL_NOTIFICATION_CLICKED: 'email_notification_clicked',
    SHORT_LINK_OPENED: 'short_link_opened',
    NOTIFICATION_PREFERENCE_TOGGLED: 'notification_preference_toggled',

    VOICE_INPUT_RECORDING_STARTED: 'voice_input_recording_started',
    VOICE_INPUT_RECORDING_STOPPED: 'voice_input_recording_stopped',
    VOICE_INPUT_TRANSCRIPTION_SUCCEEDED: 'voice_input_transcription_succeeded',
    VOICE_INPUT_TRANSCRIPTION_FAILED: 'voice_input_transcription_failed',
    VOICE_INPUT_MESSAGE_SENT: 'voice_input_message_sent',
    VOICE_INPUT_FEEDBACK_SUBMITTED: 'voice_input_feedback_submitted',

    CONVERSATION_MESSAGE_SENT: 'conversation_message_sent',
    CONVERSATION_RUN_INTERRUPTED: 'conversation_run_interrupted',

    CONVERSATION_QUEUE_SWITCHED: 'conversation_queue_switched',
    CONVERSATION_STATUS_FILTER_CHANGED: 'conversation_status_filter_changed',
    CONVERSATION_READ_FILTER_CHANGED: 'conversation_read_filter_changed',
    CONVERSATION_INBOX_VIEW_SWITCHED: 'conversation_inbox_view_switched',
    CONVERSATION_ASSIGNED: 'conversation_assigned',
    CONVERSATION_CLOSED: 'conversation_closed',
    CONVERSATION_REOPENED: 'conversation_reopened',
    CONVERSATION_CARD_DRAG_REASSIGNED: 'conversation_card_drag_reassigned',
    // Contact Activity Timeline panel (flag `conversation_ownership_enabled`).
    CONTACT_ACTIVITY_PANEL_TOGGLED: 'contact_activity_panel_toggled',
    CONTACT_ACTIVITY_ROW_CLICKED: 'contact_activity_row_clicked',
    CONTACT_ACTIVITY_LOAD_MORE: 'contact_activity_load_more',
    PHOEBE_AGENT_RUN_EVENT_STREAM_FAILED:
        'phoebe_agent_run_event_stream_failed',
    V3_CHAT_COMPOSER_READY: 'v3_chat_composer_ready',
    V3_CHAT_TURN_PERFORMANCE: 'v3_chat_turn_performance',
    DYNAMIC_WIDGET_BUILT: 'dynamic_widget_built',
    DYNAMIC_WIDGET_PRESENTATION: 'dynamic_widget_presentation',
    DYNAMIC_WIDGET_FIRST_USEFUL: 'dynamic_widget_first_useful',
    DYNAMIC_WIDGET_FALLBACK: 'dynamic_widget_fallback',
    DYNAMIC_WIDGET_BINDING_MISSING: 'dynamic_widget_binding_missing',
    DYNAMIC_WIDGET_ACTION_SUBMITTED: 'dynamic_widget_action_submitted',
    DYNAMIC_WIDGET_ACTION_SUCCEEDED: 'dynamic_widget_action_succeeded',
    DYNAMIC_WIDGET_ACTION_FAILED: 'dynamic_widget_action_failed',
    DYNAMIC_WIDGET_ACTION_TERMINAL_TIMING:
        'dynamic_widget_action_terminal_timing',
    DYNAMIC_WIDGET_ISSUE_SHOWN: 'dynamic_widget_issue_shown',
    DYNAMIC_WIDGET_DIAGNOSTIC_ATTACHED: 'dynamic_widget_diagnostic_attached',
    ASK_USER_QUESTION_CARD_SHOWN: 'ask_user_question_card_shown',
    ASK_USER_QUESTION_CARD_SUBMITTED: 'ask_user_question_card_submitted',
    ASK_USER_QUESTION_CARD_CANCELLED: 'ask_user_question_card_cancelled',

    AGENT_AUTOMATION_LIST_VIEWED: 'agent_automation_list_viewed',
    AGENT_AUTOMATION_CREATE_OPENED: 'agent_automation_create_opened',
    AGENT_AUTOMATION_EDIT_OPENED: 'agent_automation_edit_opened',
    AGENT_AUTOMATION_DETAIL_VIEWED: 'agent_automation_detail_viewed',
    AGENT_AUTOMATION_RUN_OPENED: 'agent_automation_run_opened',
    AGENT_AUTOMATION_DELETE_DIALOG_OPENED:
        'agent_automation_delete_dialog_opened',

    REFERRAL_PROGRAM_VIEWED: 'referral_program_viewed',
    REFERRAL_LINK_COPIED: 'referral_link_copied',

    TRAIN_PHOEBE_PAGE_VIEWED: 'train_phoebe_page_viewed',
    TRAIN_PHOEBE_RUN_OPENED: 'train_phoebe_run_opened',
    TRAIN_PHOEBE_RUN_REVIEWED: 'train_phoebe_run_reviewed',

    LEARN_PHOEBE_PAGE_VIEWED: 'learn_phoebe_page_viewed',
    LEARN_PHOEBE_TASK_OPENED: 'learn_phoebe_task_opened',
    LEARN_PHOEBE_TRY_IN_CHAT_CLICKED: 'learn_phoebe_try_in_chat_clicked',
    LEARN_PHOEBE_PROMPT_COPIED: 'learn_phoebe_prompt_copied',
    LEARN_PHOEBE_CHECKLIST_OPENED: 'learn_phoebe_checklist_opened',
    LEARN_PHOEBE_PROMPT_SEEDED: 'learn_phoebe_prompt_seeded',

    CALENDAR_OUTREACH_PROMPT_SEEDED: 'calendar_outreach_prompt_seeded',

    // Coverage grid and Training Coverage gap list: bulk "ask availability"
    // action. REQUESTED fires once per batch seeded into the general-agent
    // composer; all batches from one continuous selection share a
    // selection_id so they can be grouped into one funnel. CLEARED fires
    // when a non-empty selection is cleared, reporting how many of its
    // batches were asked before that point (0 = abandoned before asking).
    BULK_ASK_AVAILABILITY_REQUESTED: 'bulk_ask_availability_requested',
    BULK_ASK_AVAILABILITY_SELECTION_CLEARED:
        'bulk_ask_availability_selection_cleared',

    // Coverage dashboard page (Grid/Coverage/Map tabs) usage: view counts,
    // which tab is used, and time spent. No caregiver identifiers.
    COVERAGE_PAGE_VIEWED: 'coverage_page_viewed',
    COVERAGE_TAB_CHANGED: 'coverage_tab_changed',
    COVERAGE_PAGE_LEFT: 'coverage_page_left',

    // Training Coverage's caregiver gap-list modal (setup_checklist_card.tsx).
    // Fires on open so "nobody opens this" and "people open it and select
    // nobody" are distinguishable from the bulk-ask events alone.
    TRAINING_COVERAGE_GAP_LIST_OPENED: 'training_coverage_gap_list_opened',

    // Calendar shift-view page.
    CALENDAR_PAGE_VIEWED: 'calendar_page_viewed',
    CALENDAR_SHIFTS_LOADED: 'calendar_shifts_loaded',
    CALENDAR_VIEW_MODE_CHANGED: 'calendar_view_mode_changed',
    CALENDAR_GROUP_BY_CHANGED: 'calendar_group_by_changed',
    CALENDAR_CAREGIVER_SORT_CHANGED: 'calendar_caregiver_sort_changed',
    CALENDAR_CUSTOM_VIEW_CHANGED: 'calendar_custom_view_changed',
    CALENDAR_RANGE_NAVIGATED: 'calendar_range_navigated',
    CALENDAR_SAVED_VIEW_SELECTED: 'calendar_saved_view_selected',
    CALENDAR_FILTER_CHANGED: 'calendar_filter_changed',
    CALENDAR_FILTERS_CLEARED: 'calendar_filters_cleared',
    CALENDAR_SHIFTS_SELECTED: 'calendar_shifts_selected',
    CALENDAR_SELECTION_CLEARED: 'calendar_selection_cleared',
    CALENDAR_OUTREACH_STARTED: 'calendar_outreach_started',
    CALENDAR_SHIFT_POPOVER_OPENED: 'calendar_shift_popover_opened',
    CALENDAR_POPOVER_CTA_CLICKED: 'calendar_popover_cta_clicked',
    CALENDAR_DAY_SUMMARY_OPENED: 'calendar_day_summary_opened',

    // New activity board (activity_feed_redesign_enabled flag): the kanban
    // board on /activity?presentation=board. Every event carries
    // `presentation` ('board' | 'list') so the two layouts of the same
    // component can be compared. Item-level events also carry the shared
    // activity-event fields (activity_event_kind, priority, lane) used by
    // the classic ACTIVITY_FEED_* events.
    ACTIVITY_BOARD_VIEWED: 'activity_board_viewed',
    // Fires from the /activity route when the user toggles between the
    // classic list and the board (`from_presentation`/`to_presentation`).
    ACTIVITY_BOARD_PRESENTATION_SWITCHED:
        'activity_board_presentation_switched',
    ACTIVITY_BOARD_TAB_SELECTED: 'activity_board_tab_selected',
    // One event for the filter bar: `filter_type` is lane | status | office
    // | assignee | chip | date_range, `action` is include | exclude | add |
    // remove | set | clear | clear_all.
    ACTIVITY_BOARD_FILTER_CHANGED: 'activity_board_filter_changed',
    ACTIVITY_BOARD_SORT_CHANGED: 'activity_board_sort_changed',
    // `action`: applied | created | updated | renamed | deleted.
    ACTIVITY_BOARD_SAVED_VIEW_CHANGED: 'activity_board_saved_view_changed',
    // Detail sheet opened for one item.
    ACTIVITY_BOARD_ITEM_OPENED: 'activity_board_item_opened',
    // Items resolved (marked addressed). `event_count` carries the batch
    // size; `surface` is item | selection | matching.
    ACTIVITY_BOARD_RESOLVED: 'activity_board_resolved',
    ACTIVITY_BOARD_REOPENED: 'activity_board_reopened',
    // Items handed to the Ask Phoebe composer. `surface` is card_action
    // (a card's suggested action) | selection (the bulk selection bar).
    ACTIVITY_BOARD_ASK_PHOEBE: 'activity_board_ask_phoebe',

    SETTINGS_REDESIGN_PAGE_VIEWED: 'settings_redesign_page_viewed',
    SETTINGS_REDESIGN_TAB_SELECTED: 'settings_redesign_tab_selected',
    SETTINGS_REDESIGN_SEARCH_PERFORMED: 'settings_redesign_search_performed',
    SETTINGS_REDESIGN_PAGE_LEFT: 'settings_redesign_page_left',
    SETTINGS_CLASSIC_PAGE_LEFT: 'settings_classic_page_left',
    SETTINGS_CHANGED: 'settings_changed',

    COMPOSER_HINT_ACCEPTED: 'composer_hint_accepted',
    COMPOSER_HINT_DISMISSED: 'composer_hint_dismissed',

    // Voice Calls page. `VOICE_CALLS_VIEW_SWITCHED` carries a `view`
    // property of 'list' | 'table'; `VOICE_CALLS_TABLE_ROW_OPENED` fires
    // when a row in the dense table view is clicked to open call details.
    VOICE_CALLS_VIEW_SWITCHED: 'voice_calls_view_switched',
    VOICE_CALLS_TABLE_ROW_OPENED: 'voice_calls_table_row_opened',
    // Fires when a voice call is assigned (or reassigned) to a teammate from
    // the voice-calls page.
    VOICE_CALL_ASSIGNED: 'voice_call_assigned',
};
